import React, { FC, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import HistoryIcon from '@material-ui/icons/History';
import { makeStyles } from '@material-ui/core/styles';
import { InjectedFieldProps, PublicFieldProps } from 'react-admin';
import { JobPhaseReceivableSheetInterface } from '@vatos-pas/common';

import { PermissionsProvider } from 'providers/permissionsProvider';
import { CAN_SEE_RECEIVABLE_HISTORY } from 'providers/permissions';

import { useReceivableId } from '../hooks/ReceivableRegistry';
import { ReceivableHistoryModal } from './ReceivableHistoryModal';

type InvoiceHistoryFieldProps = PublicFieldProps &
  InjectedFieldProps<JobPhaseReceivableSheetInterface>;

const useStyles = makeStyles({
  historyIcon: {
    color: '#757575',
  },
});

// Empty-header column: the lone invoice change-history icon. Its modal tracks
// both invoicePOAmount and internalInvoiceNumber (variant="invoice").
export const InvoiceHistoryField: FC<InvoiceHistoryFieldProps> = ({
  record,
}) => {
  const classes = useStyles();
  const { hasPermission } = PermissionsProvider.useContainer();
  const receivableId = useReceivableId(record);
  const [historyOpen, setHistoryOpen] = useState(false);

  if (!record) return null;
  if (!hasPermission(CAN_SEE_RECEIVABLE_HISTORY)) return null;

  return (
    <>
      <IconButton
        size="small"
        onClick={() => setHistoryOpen(true)}
        aria-label="View invoice change history"
      >
        <HistoryIcon className={classes.historyIcon} />
      </IconButton>
      <ReceivableHistoryModal
        open={historyOpen}
        jobPhaseReceivableId={receivableId}
        variant="invoice"
        onClose={() => setHistoryOpen(false)}
      />
    </>
  );
};

export default InvoiceHistoryField;
